// extracted by mini-css-extract-plugin
module.exports = {"outputBox":"styles_outputBox__2a6SH","loaderWrapper":"styles_loaderWrapper__2Q9jI","outputContent":"styles_outputContent__2urrT"};